




























































































































































































































































import draggable from "vuedraggable";
import { sortItems, getAnswer } from "@/services/checklist.service";
import { validateFormulaSyntax, findUnknownVars } from "@/services/formula_validator";
import { EventBus } from "@/event-bus";
import MachinesModal from "@/components/MachinesModal.vue";
import TranslatedItem from "@/components/TranslatedItem.vue";
import ClTableColumns from "./ClTableColumns.vue";
import CondFormatEditor from "./CondFormatEditor.vue";

export default {
  props: ["questionLoaded"],
  data() {
    return {
      filter1: null,
      answer_list: null,
      org_entry: {},
      org_machines: [],
      username: null,
      bc: null,
      showMachines: false,
      field_message_name_en: [],
      field_message_name_fr: [],
      sel_removemachines: [],
      sel_addmachines: [],
      sel_machinesingroup: [],
      calcExpanded: false,
      question_fieldtype: [
        { text: this.$t('LABEL27'), value: "input" },
        { text: this.$t('LABEL28'), value: "textarea" },
        { text: this.$t('LABEL29'), value: "checkbox" },
        { text: this.$t('LABEL30'), value: "radio" },
        { text: this.$t('LABEL31'), value: "select" },
        { text: this.$t('LABEL32'), value: "calledContacts" },
        { text: this.$t('LABEL33'), value: "range" },
        { text: this.$t('LABEL34'), value: "serialNumber" },
        { text: this.$t('LABEL35'), value: "signature" },
        { text: this.$t('LABEL36'), value: "location" },
        { text: this.$t('LABEL37'), value: "radius" },
        { text: this.$t('LABEL38'), value: "barcode" },
        { text: this.$t('LABEL_TABLE'), value: "table" },
      ],
      question_fieldsubtype: [
        { text: "Text", value: "text" },
        { text: "Number", value: "number" },
        { text: "Date/Time", value: "datetime-local" },
        { text: "Date", value: "date" },
        { text: "Time", value: "time" },
        { text: "E-Mail", value: "email" },
      ],
    };
  },
  components: {
    draggable,
    MachinesModal,
    TranslatedItem,
    ClTableColumns,
    CondFormatEditor,
  },
  computed: {
    appLang: function () {
      return this.$store.state.lang
    },
    onlyPV: function () {
      return this.$store.getters.userRole.db_region //this.userRole.db_region == 'eso'
    },
    pasteEntryVal() {
      return this.$store.state.pasteEntryOptionVal;
    },
    copy_entry() {
      return (
        this.$store.state.copy_entry &&
        this.$store.state.copy_entry.type == "question"
      );
    },
    show_subtype() {
      return this.entry && this.entry.fieldtype == "input";
    },
    entry() {
      if (this.$store.state.cl_question) {
        if (!this.$store.state.cl_question.format) {
          this.$store.state.cl_question.format = "%K: %V %U\n";
          this.$store.state.cl_question.format_en = "%K: %V %U\n";
        }

        if (!this.$store.state.cl_question.machinegroup_list) {
          this.$store.state.cl_question.machinegroup_list = [];
        }

        if (this.$store.state.cl_question.machinegroup) {
          if (!this.$store.state.cl_question.machinegroup_created) {
            this.$store.state.cl_question.machinegroup_created = true;
            this.$store.state.cl_question.machinegroup_list = [
              this.$store.state.cl_question.machinegroup,
            ];
          }
        }

        this.$store.state.cl_component.machinegroup_created = true;

        return this.$store.state.cl_question;
      }
      return {};
    },
    answers: {
      get() {
        return this.$store.state.cl_answer_list;
      },
      set(value) {
        this.$store.state.cl_answer_list = value;
      },
    },
    machinegroups() {
      return this.$store.state.cl_machine_groups;
    },
    projects() {
      return this.$store.state.projects;
    },
    machines() {
      if (this.filter1 && this.filter1.length > 0) {
        return this.$store.state.machines.filter((machine) => {
          return (
            machine.text.toLowerCase().indexOf(this.filter1.toLowerCase()) !==
            -1
          );
        });
      }
      return this.$store.state.machines;
    },
    saving() {
      return (
        this.$store.state.saving && this.$store.state.saving_type == "question"
      );
    },
    hasChanges() {
      if (!this.org_entry || !this.entry || !this.org_entry._id) return false;
      let a = { ...this.org_entry }; let b = { ...this.entry };
      delete a.created_at; delete b.created_at;
      delete a.user_uid; delete b.user_uid;
      return JSON.stringify(a) !== JSON.stringify(b);
    },
    show_answers() {
      return (
        this.entry.fieldtype == "radio" ||
        this.entry.fieldtype == "select" ||
        this.entry.fieldtype == "checkbox"
      );
    },
    calcFormulaIdError() {
      const id = (this.entry.calcFormulaId || "").trim();
      if (id === "") return [];
      if (!/^[a-zA-Z_][a-zA-Z0-9_]*$/.test(id)) return [this.$t("CALC_FORMULA_ID_INVALID")];
      const siblings = (this.$store.state.cl_question_list || [])
        .filter((f) => f && f._id !== this.entry._id);
      if (siblings.some((f) => f.calcFormulaId === id)) return [this.$t("CALC_FORMULA_ID_DUPLICATE")];
      return [];
    },
    calcValueFormulaError() {
      return this._validateFormulaField(this.entry.calcValueFormula);
    },
    calcMinFormulaError() {
      return this._validateFormulaField(this.entry.calcMinFormula);
    },
    calcMaxFormulaError() {
      return this._validateFormulaField(this.entry.calcMaxFormula);
    },
  },
  mounted() {
    EventBus.$on("question_changed", this.questionChangedHandler);
    EventBus.$on("updateInformElement", this.updateInformElement);

    if (!this.bc) {
      this.bc = new BroadcastChannel("checklist");
      this.bc.onmessage = (eventMessage) => {
        if (eventMessage.data && eventMessage.data.type == "COPY_OPTION") {
          this.$store.state.pasteEntryOptionVal = eventMessage.data.pasteItem;
        }
      };
    }

    this.updateUsername();
  },
  destroyed() {
    EventBus.$off("question_changed", this.questionChangedHandler);
    EventBus.$off("updateInformElement", this.updateInformElement);
  },
  /*
  watch: {
    answers: function (val, oldVal) {
      console.log("watch answers")
      this.answer_list = val
    }
  },
  */
  watch: {
    "entry._id": {
      immediate: true,
      handler() {
        const e = this.entry || {};
        const hasCalc =
          (e.calcFormulaId && e.calcFormulaId.length > 0) ||
          (e.calcValueFormula && e.calcValueFormula.length > 0) ||
          (e.calcMinFormula && e.calcMinFormula.length > 0) ||
          (e.calcMaxFormula && e.calcMaxFormula.length > 0) ||
          (Array.isArray(e.calcMapping) && e.calcMapping.length > 0);
        this.calcExpanded = !!hasCalc;
      },
    },
  },
  methods: {
    _validateFormulaField(formula) {
      const result = validateFormulaSyntax(formula);
      if (!result.ok) return [result.error];
      const siblings = this.$store.state.cl_question_list || [];
      const unknown = findUnknownVars(formula, siblings, this.entry._id);
      if (unknown.length > 0) {
        return [this.$t("CALC_FORMULA_REF_UNKNOWN").replace("{var}", unknown.join(", "))];
      }
      return [];
    },
    addCalcMapping() {
      if (!this.entry.calcMapping) this.$set(this.entry, "calcMapping", []);
      this.entry.calcMapping.push({ key: "", value: 0 });
    },
    removeCalcMapping(idx) {
      this.entry.calcMapping.splice(idx, 1);
    },
    updateInformElement: function (d) {
      if (d.type != "question" && d.uid != this.entry.uid) {
        console.log("QUESTION speichern");
        this.save();
      }
    },
    rowclick(item) {
      this.$emit("selectAnswer", item);
    },
    createAct: function (type) {
      this.$emit("createAct", { type: type });
    },
    sortAct: function (type) {
      this.$emit("sortAct", { type: type });
    },
    deleteAct: function (type) {
      this.entry.type = type;
      this.$emit("deleteAct", this.entry);
    },
    copyAct: function (type) {
      this.entry.type = type;
      this.$emit("copyAct", {
        type: type,
        cl_uid: this.entry.cl_uid,
        uid: this.entry.uid,
        name: this.entry.name,
      });
    },
    close: function () {
      EventBus.$emit("question_closed", this.entry);
    },
    pasteEntry: function () {
      this.$emit("pasteAct");
    },
    pasteOptionEntry: function (item) {
      item.paste_cl_uid = this.entry.cl_uid;
      item.paste_question_uid = this.entry.uid;

      this.$emit("duplicateAct", { type: "answer", item: item });

      console.log("pasteOptionEntry", item);
      // paste_cl_uid
      // paste_question_uid

      /*
      getAnswer(item.cl_uid, item.uid)
        .then(resp => { 
          console.log("resp", resp)
        })
      */
    },
    onSortEnd: function () {
      sortItems(this.answers, {
        type: "answer",
        cl_uid: this.$store.state.cl_uid,
      })
        .then((resp) => {
          if (resp.status == "success") {
          }
        })
        .catch((e) => {
          console.log("error", e);
        });
    },
    copyEntry: function (e, item, duplicate) {
      e.stopPropagation();
      if (duplicate) {
        item.cl_uid = this.$store.state.cl_uid;
        this.$emit("duplicateAct", { type: "answer", item: item });
      } else {
        console.log(item);
        this.$store.state.pasteEntryOptionVal = {
          text: item.text,
          value: item.value,
          cl_uid: this.$store.state.cl_uid,
        };
        this.bc.postMessage({
          type: "COPY_OPTION",
          pasteItem: this.pasteEntryVal,
        });
      }
    },
    updateUsername: function () {
      if (this.entry.user_uid) {
        this.username = this.$store.state.users[this.entry.user_uid];
      } else {
        this.username = "";
      }
    },
    save() {
      //this.loading = true;

      let check1 = { ...this.org_entry };
      let check2 = { ...this.entry };
      delete check1.created_at;
      delete check2.created_at;
      delete check1.user_uid;
      delete check2.user_uid;
      delete check1.type;
      delete check2.type;

      this.entry.type = "question";

      if (
        JSON.stringify(check1) != JSON.stringify(check2) ||
        this.entry.machines.length != this.org_machines.length
      ) {
        this.entry.user_uid = this.$store.state.userId;
        this.entry.created_at = Date.now();
        this.updateUsername();
        this.org_entry = { ...this.entry };
        this.$emit("updateAct", this.entry);
        EventBus.$emit("updateInformElement", {
          type: "question",
          uid: this.entry.uid,
        });
      } else {
        this.$emit("updateAct", { no_changes: true });
      }
    },
    questionChangedHandler: function (data) {
      this.org_entry = { ...this.entry };
      this.org_machines = JSON.parse(JSON.stringify(this.entry.machines));
      this.updateUsername();
    },
    dialogClosed: function (val) {
      this.showMachines = false;
    },
    changeMachines: function (val) {
      this.showMachines = false;
      // {add_machines: this.add_machines, remove_machines: this.remove_machines}
      this.entry.machines = val.add_machines;
      this.entry.remove_machines = val.remove_machines;

      if (val.group_uid) {
        // Es wurde eine neue Gruppe aus der Auswahl erstellt
        this.entry.machinegroup_list = [val.group_uid];
      }
    },
    openMachinesDialog: function () {
      this.sel_addmachines = JSON.parse(JSON.stringify(this.entry.machines));
      this.sel_removemachines = JSON.parse(
        JSON.stringify(this.entry.remove_machines)
      );
      this.showMachines = true;

      this.sel_machinesingroup = [];

      if (this.machinegroups) {
        for (let k of this.machinegroups) {
          if (this.entry.machinegroup_list) {
            for (let m of this.entry.machinegroup_list) {
              if (k.value == m) {
                this.sel_machinesingroup = this.sel_machinesingroup.concat(
                  JSON.parse(JSON.stringify(k.machines))
                );
              }
            }
          } else {
            if (k.value == this.entry.machinegroup) {
              this.sel_machinesingroup = JSON.parse(JSON.stringify(k.machines));
              break;
            }
          }
        }
      }
    },

  },
};
